import { PROVINCES } from './Common';


export default [
    PROVINCES.ALBERTA,
    PROVINCES.BRITISH_COLUMBIA,
    PROVINCES.ONTARIO,
    PROVINCES.QUEBEC,
];